import { TRootState } from '../reducers';
import { IAttachmentError, IErrorsState, IGeneralError } from '../reducers/types';

const selectState = (state: TRootState): IErrorsState => {
  return state.errors;
};

export const selectHasError = (state: TRootState): boolean => {
  return selectState(state).errors.length > 0;
};

export const selectErrors = (state: TRootState): IGeneralError[] | IAttachmentError[] => {
  return selectState(state).errors;
};
